import { automationRoute, propertiesRoute, loginRoute, rawPropertiesRoute} from "./constants.ts";
// site/src/helpers.js
const getToken = () => localStorage.getItem('authToken');

const apiFetch = (url, opts = {}) => {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(url, { ...opts, headers });
};

// use apiFetch everywhere
// const fetchProperties = async (cb) => {
//   try {
//     const res = await apiFetch(propertiesRoute);
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//     cb(await res.json());
//   } catch (e) { console.error('Error fetching properties:', e); }
// };

// const fetchLogin = async (verify, email, password) => {
//   try {
//     const res = await fetch(loginRoute, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ email: email.toLowerCase(), password }),
//     });
//     if (!res.ok) throw new Error((await res.json()).error || 'Login failed');
//     const data = await res.json();
//     if (data.success && data.token) {
//       localStorage.setItem('authToken', data.token);
//       verify(data.user);
//     } else {
//       verify(null);
//     }
//   } catch (e) {
//     console.error('Error during login:', e.message);
//     verify(null);
//   }
// };

const runAutomation = async (status) => {
  try {
    // Example payload to send to the backend
    const payload = {
      // state: 'CA', // Replace with the desired state or other parameters
    };

    const response = await fetch(automationRoute, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload), // Send the payload to the backend
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json(); // Parse the JSON response
    console.log('Automation result:', result);

  } catch (error) {
    console.error('Error running automation:', error);
  }
};

const fetchProperties = async (cb) => {
  try {
    const response = await fetch(propertiesRoute);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    cb(data); 
  } catch (error) {
    console.error('Error fetching properties:', error);
  }
};

const fetchRawProperties = async (cb) => {
  try {
    const response = await fetch(rawPropertiesRoute);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    cb(data); 
  } catch (error) {
    console.error('Error fetching properties:', error);
  }
};

const fetchLogin = async (verify, email, password) => {
  const caseInsensitiveEmail = email.toLowerCase();
  try {
    const response = await fetch(loginRoute, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: caseInsensitiveEmail, password }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Login failed');
    }

    const data = await response.json();

    if (data.success) {
      console.log('Login successful:', data);
      localStorage.setItem('authToken', data.token);
      verify(data.user); // Pass the response data to the callback
    } else {
      console.error('Login failed:', data.error);
      verify(null); // Pass null to indicate failure
    }
  } catch (error) {
    console.error('Error during login:', error.message);
    verify(null); // Pass null to indicate failure
  }
};

export { runAutomation, fetchProperties, fetchLogin, apiFetch, fetchRawProperties };